var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.7C14.5,63.7,0.3,49.5,0.3,32S14.5,0.3,32,0.3S63.7,14.5,63.7,32S49.5,63.7,32,63.7z M32,5.1 C17.1,5.1,5.1,17.1,5.1,32S17.1,58.9,32,58.9S58.9,46.9,58.9,32S46.9,5.1,32,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,46.6c0,0-3.2-7-4.3-9.7c-1.1-2.7-2.1-3.1-3.5-3.1h-2.2c-0.9-1-2-1.7-3.2-2.3v-7.7c0-1.1-0.8-3.2-2.4-3.2 s-1.7,0.2-4.5,2.4s-3,2.8-3,4.2v5.2c-2.7,1.9-4.3,4.9-4.3,8.2c0,5.5,4.5,10,10,10c4.8,0,9-3.5,9.8-8.2c0.5,1.5,1.5,4.1,2.2,6.1 c1.1,3,3.2,2.7,4.4,2.1C45.8,50,46.3,48.2,45.6,46.6z M28.2,47.7c-3.9,0-7.1-3.2-7.1-7.1c0-1.9,0.8-3.7,2.1-5v2.2 c0,2.1,1.4,3,2.4,3c1,0,2.5-0.8,2.5-2.9v-4.3c3.9,0,7.1,3.2,7.1,7.1C35.3,44.6,32.1,47.7,28.2,47.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7013_00000131345723980058135320000012868223872965379978_",
    className: "st0",
    cx: 32.5,
    cy: 15.8,
    r: 3.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType16);
export default __webpack_public_path__ + "static/media/aioa-icon-type-16.70b243b8744ab8afc098bbe8f1b71991.svg";
export { ForwardRef as ReactComponent };